import Enums from "../../../../utils/Enums";

const GEMMBenefits = {
  headers: [
    {
      title: `Benefits / Plan Type`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    },
    {
      title: `Plan 5`,
      tier: 5
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>Provides reimbursement of eligible expenses in excess of Basic GHS</strong>`,
          info: `if:<br><ol type="a">
          <li>Hospitalisation is at least 20 days; or</li>
          <li>Surgical Percentage is at least 75% per incision</li>
          </ol>`
        },
        {
          data: `S$ 80,000`,
          info: `per disability`
        },
        {
          data: `S$ 60,000`,
          info: `per disability`
        },
        {
          data: `S$ 40,000`,
          info: `per disability`
        },
        {
          data: `S$ 20,000`,
          info: `per disability`
        },
        {
          data: `S$ 60,000`,
          info: `per disability`
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>Daily Home Nursing Benefit</strong>`,
          info: `(max. per day, up to 30 days per disability)`
        },
        {
          data: `S$ 80 per day for all plans`,
          info: `(subject to respective benefit limit)`,
          attributes: {
            colspan: 5
          }
        }
      ]
    },
    {
      id: 3,
      columns: [
        {
          data: `<strong>HIV Due to Blood Transfusion and Occupationally Acquired HIV</strong>`
        },
        {
          data: `S$ 5,000 per policy year`,
          info: `(subject to respective benefit limit)`,
          attributes: {
            colspan: 5
          }
        }
      ]
    },
    {
      id: 4,
      columns: [
        {
          data: `<strong>Parent Accommodation</strong>`,
          info: `(up to 60 days for accompanying child age 12 and below)`
        },
        {
          data: `S$ 100 per day for all plans`,
          info: `(subject to respective benefit limit)`,
          attributes: {
            colspan: 5
          }
        }
      ]
    },
    {
      id: 5,
      columns: [
        {
          data: `<strong>Deductible</strong>`
        },
        {
          data: `As per Basic GHS`,
          attributes: {
            colspan: 5
          }
        }
      ]
    },
    {
      id: 6,
      columns: [
        {
          data: `<strong>Co-Insurance</strong>`
        },
        {
          data: `20%`,
          attributes: {
            colspan: 5
          }
        }
      ]
    }
  ],
  footnotes: []
};

let GEMMPremiumEmployee = {
  title: `<strong>For Employee Only</strong> <i>(inclusive of 7% GST)</i>`,
  headers: [
    {
      title: `Age Last Birthday`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    },
    {
      title: `Plan 5`,
      tier: 5
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>16 - 69</strong>`
        },
        {
          data: `S$ 37.00`
        },
        {
          data: `S$ 29.00`
        },
        {
          data: `S$ 19.00`
        },
        {
          data: `S$ 10.00`
        },
        {
          data: `S$ 14.00`
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>70 - 74</strong>`,
          info: `For renewals only`
        },
        {
          data: `S$ 37.00`
        },
        {
          data: `S$ 29.00`
        },
        {
          data: `S$ 19.00`
        },
        {
          data: `S$ 10.00`
        },
        {
          data: `S$ 14.00`
        }
      ]
    }
  ],
  footnotes: []
};

let GEMMPremiumSpouseOrChildren = {
  title: `<strong>For Employee and Spouse or Children Coverage Only</strong> <i>(inclusive of 7% GST)</i>`,
  headers: [
    {
      title: `Age Last Birthday`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    },
    {
      title: `Plan 5`,
      tier: 5
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>16 - 69</strong>`
        },
        {
          data: `S$ 83.25`
        },
        {
          data: `S$ 65.25`
        },
        {
          data: `S$ 42.75`
        },
        {
          data: `S$ 22.50`
        },
        {
          data: `S$ 31.50`
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>70 - 74</strong>`,
          info: `For renewals only`
        },
        {
          data: `S$ 83.25`
        },
        {
          data: `S$ 65.25`
        },
        {
          data: `S$ 42.75`
        },
        {
          data: `S$ 22.50`
        },
        {
          data: `S$ 31.50`
        }
      ]
    }
  ],
  footnotes: []
};

let GEMMPremiumSpouseAndChildren = {
  title: `<strong>For Employees and Spouse and Children Coverage</strong> <i>(inclusive of 7% GST)</i>`,
  headers: [
    {
      title: `Age Last Birthday`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    },
    {
      title: `Plan 5`,
      tier: 5
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>16 - 69</strong>`
        },
        {
          data: `S$ 129.50`
        },
        {
          data: `S$ 101.50`
        },
        {
          data: `S$ 66.50`
        },
        {
          data: `S$ 35.00`
        },
        {
          data: `S$ 49.00`
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>70 - 74</strong>`,
          info: `For renewals only`
        },
        {
          data: `S$ 129.50`
        },
        {
          data: `S$ 101.50`
        },
        {
          data: `S$ 66.50`
        },
        {
          data: `S$ 35.00`
        },
        {
          data: `S$ 49.00`
        }
      ]
    }
  ],
  footnotes: []
};
//   ----------------------------------------------------------------------
const GEMM = {
  id: 1,
  code: "GEMM",
  label: "Group Extended Major Medical (GEMM)",
  types: [
    {
      id: 1,
      order: 1,
      type: Enums.PLANS_TYPE.BENEFITS,
      label: "Plans by Benefits",
      data: [GEMMBenefits]
    },
    {
      id: 2,
      order: 2,
      type: Enums.PLANS_TYPE.PREMIUMS,
      label: "Plans by Premium (inclusive of 7% GST)",
      data: [GEMMPremiumEmployee, GEMMPremiumSpouseOrChildren, GEMMPremiumSpouseAndChildren]
    }
  ]
};

export default GEMM;
